import NextImage, { StaticImageData } from "next/legacy/image";
import { PropsWithChildren } from "react";
import styles from "./RoadMapItem.module.css";
import Tick from "../../assets/Tick.svg";
import cx from "classnames";
import { Link, IconWithLabel } from "../Actions";

type RoadMapItemProps = {
  image: StaticImageData;
  textLeft: boolean;
  complete: boolean;
  nextComplete: boolean;
  title: string;
  description: string;
  index: number;
  link?: { href: string; text: string };
};

const Status: React.FC<{ isComplete: boolean; nextIsComplete: boolean }> = ({
  isComplete,
  nextIsComplete
}) => {
  const containerClassName = cx(
    "absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] w-[30px] h-[30px] rounded-full text-white flex items-center justify-center",
    {
      "bg-coinage-teal": isComplete,
      "bg-coinage-stroke": !isComplete
    }
  );
  const lineClassName = cx("w-[2px] h-full relative col-start-2 row-start-1	", {
    [styles.topComplete]: isComplete && !nextIsComplete,
    [styles.noComplete]: !isComplete && !nextIsComplete,
    [styles.bothComplete]: isComplete && nextIsComplete
  });
  return (
    <div className={`flex justify-center ${styles.col2}`}>
      <div className={lineClassName}>
        <div className={containerClassName}>
          {isComplete ? <Tick width="10" /> : null}
        </div>
      </div>
    </div>
  );
};

export const RoadMapItem: React.FC<PropsWithChildren<RoadMapItemProps>> = ({
  image,
  complete,
  nextComplete,
  textLeft,
  title,
  description,
  children,
  link,
  index
}) => {
  const imageClass = cx("row-start-1  ", {
    "col-start-1": !textLeft,
    "col-start-3": textLeft
  });
  const contentClass = cx("row-start-1	flex flex-col justify-center ", {
    "col-start-1": textLeft,
    "col-start-3": !textLeft
  });
  return (
    <section
      className={`${styles.roadmapItem} ${textLeft ? styles.textLeft : ""}`}>
      <div className={`${contentClass} ${styles.col1}`}>
        <h1 className="subhead1 mb-3">{title}</h1>
        <p className="body1 text-coinage-gray mb-5">{description}</p>
        {link && (
          <Link analyticsProperty="about" modifier="secondary" href={link.href}>
            {link.text}
          </Link>
        )}
        {children}
      </div>
      <Status isComplete={complete} nextIsComplete={nextComplete} />
      <div
        className={`${imageClass} ${styles.col3} ${
          index == 0 ? "pt-0 pb-12" : "py-12"
        } 
        ${index == 2 ? "pb-0" : ""}
        `}>
        <NextImage layout="responsive" alt={title} src={image} />
      </div>
    </section>
  );
};
